export default __webpack_public_path__ + "static/abc7news-d0e614fb89f85c50cfd4f27069bc967f.svg";